export default "__VITE_ASSET__CZuVSIvI__"